// frontend/src/components/common/TimeframeSelector.tsx
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const GROUPS = [
  { label: "Sec", options: ["1s", "5s", "15s", "30s"] },
  { label: "Min", options: ["1m", "2m", "3m", "5m", "10m", "15m", "30m"] },
  { label: "Hr", options: ["1H", "2H", "3H", "4H", "6H", "8H", "12H", "16H", "23H"] },
  { label: "Day+", options: ["D", "2D", "4D", "W", "M"] },
] as const;

function findGroup(value: string): string | null {
  for (const group of GROUPS) {
    if ((group.options as readonly string[]).includes(value)) {
      return group.label;
    }
  }
  return null;
}

interface TimeframeSelectorProps {
  value: string | null;
  onChange: (value: string) => void;
}

export function TimeframeSelector({ value, onChange }: TimeframeSelectorProps) {
  const activeGroup = value ? findGroup(value) : null;

  return (
    <div className="grid grid-cols-4 gap-2">
      {GROUPS.map((group) => {
        const isActive = activeGroup === group.label;
        const selectedInGroup = isActive ? value : undefined;

        return (
          <Select
            key={group.label}
            value={selectedInGroup ?? ""}
            onValueChange={(v) => {
              if (v) onChange(v);
            }}
          >
            <SelectTrigger
              className={`h-8 text-xs ${
                isActive
                  ? "border-brand-blue/60 bg-brand-blue/10"
                  : "border-white/10 bg-white/5"
              }`}
            >
              <SelectValue placeholder={group.label} />
            </SelectTrigger>
            <SelectContent>
              {group.options.map((opt) => (
                <SelectItem key={opt} value={opt} className="text-xs">
                  {opt}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );
      })}
    </div>
  );
}
